export const ITEM_CATEGORIES = {
  bluzy: "Bluzy",
  koszulki: "Koszulki",
  spodnie: "Spodnie",
  kurtki: "Kurtki",
  buty: "Buty",
  akcesoria: "Akcesoria",
} as const

export default ITEM_CATEGORIES
